import { render, staticRenderFns } from "./consumerReward.vue?vue&type=template&id=79ef22d7&scoped=true&"
import script from "./consumerReward.vue?vue&type=script&lang=js&"
export * from "./consumerReward.vue?vue&type=script&lang=js&"
import style0 from "./consumerReward.vue?vue&type=style&index=0&id=79ef22d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef22d7",
  null
  
)

export default component.exports